export default (x: number): boolean => x >= 0 && x <= 24;
